import { ELOQUENT } from 'config/constants';

/**
 * Get logged in user's profile data
 * @returns {Promise}
 */
export function getAuthedUserProfile() {
    return ELOQUENT.User.me();
}

/**
 * Get user's reps
 * NOTE: if campaign id is passed,
 * the return object will contain `total_count` which is the total request count to this rep
 * for the given campaign
 * @param {Number} campaignId optional
 * @returns {Promise}
 */
export function getUserReps(campaignId = null) {
    return ELOQUENT.User.getMyReps({
        campaign_id: campaignId
    });
}

/**
 * Get the user's newsfeed
 * @param {Object} data
 * @returns {Promise}
 */
export function getNewsFeed(data) {
    return ELOQUENT.User.getNewsFeed(data);
}

/**
 * Get user's profile data by hash
 * @param {String} hashId
 * @returns {Promise}
 */
export function getUserByHashId(hashId) {
    return ELOQUENT.User.getViaHash(hashId);
}

/**
 * Get user's campaign rep requests
 * @param {String} id
 * @returns {Promise}
 */
export function getUserCampaignRepRequests(id) {
    return ELOQUENT.User.getCampaignRequests({
        campaign_id: id
    });
}

/**
 * Get a rep user's campaign requests
 * @param {Object} data
 * @returns {Promise}
 */
export function getRepCampaignRequests(data) {
    return ELOQUENT.User.getMyCampaignRequests(data);
}

/**
 * Get a rep user's answered campaign requests
 * @param {Object} data
 * @returns {Promise}
 */
export function getRepAnsweredCampaignRequests(data) {
    return ELOQUENT.User.getMyAnsweredCampaignRequests(data);
}

/**
 * Set a rep user's campaign requests answer
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function setRepRequestResponse(id, data) {
    return ELOQUENT.User.setMyCampaignRequests(id, data);
}

/**
 * Get all reps
 * @returns {Promise}
 */
export function getAllReps() {
    return ELOQUENT.User.getAllReps();
}

/**
 * Update the current user's profile data
 * @param {Number} id
 * @param {Object} data
 * @returns {Promise}
 */
export function updateProfileData(id, data) {
    return ELOQUENT.User.updateOne(id, data);
}

/**
 * Verify email (received after registration)
 * @param {String} token
 * @returns {Promise}
 */
export function verifyEmail(token) {
    return ELOQUENT.User.verifyEmail(token);
}

/**
 * Get
 * @param {String} token
 * @returns {Promise}
 */
export function getCampaignsTotalStats() {
    return ELOQUENT.User.getTotalCounts();
}

/**
 * add the user's unique push notification installations
 * @param {Object} data
 * @returns {Promise}
 */
export function addPNInstallations(data) {
    return ELOQUENT.User.addInstallations(data);
}
